// extracted by mini-css-extract-plugin
module.exports = {"grid":"QuestionsAndAnswers_grid__i5GgR","groupanswers":"QuestionsAndAnswers_groupanswers__Ov7UK"};